import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useReminderType, ReminderType } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<ReminderType>
      useData={useReminderType}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
